export const SectionMark = ({ n, label }) => (
  <div className="sec-mark mono" aria-hidden="true">
    <span className="sec-mark-n">{`§ ${n}`}</span>
    <span className="sec-mark-sep">/</span>
    <span>{label}</span>
  </div>
);

export const Folio = ({ n }) => (
  <div className="folio mono" aria-hidden="true">
    <span>PARALISI COGNITIVA</span>
    <span className="folio-rule" />
    <span>{`P. ${n}`}</span>
  </div>
);

export const RegMarks = () => (
  <>
    <span className="reg reg-tl" aria-hidden="true" />
    <span className="reg reg-tr" aria-hidden="true" />
  </>
);
